module.exports = __webpack_public_path__ + "img/ca.ce143108.svg";